export const getCookie = () => {
  if (typeof document === 'undefined' || !document.cookie) {
    return {};
  }

  let allCookies = document.cookie.split(';');
  let result = {};
  for (var i = 0; i < allCookies.length; i++) {
    let cookie = allCookies[i].split('=');
    let rawName = cookie[0] ? cookie[0].trim() : '';
    if (!rawName) {
      continue;
    }

    try {
      let cookieName = decodeURIComponent(rawName);
      let cookieValue = cookie[1] != null ? decodeURIComponent(cookie[1].trim()) : '';
      result[cookieName] = cookieValue;
    } catch (e) {
      // skip malformed cookie entries instead of crashing the page
    }
  }
  return result;
}

export const refreshSessionData = async () => {
  const phpApi = process.env.phpApiUrl;
  const res = await fetch(`${phpApi}/reload_session.php`, {
    credentials: 'include',
  });
  //console.log('session data=', res.status);

  if (res.status == 200) {
    return true;
  }

  return false;
}

// Parse reload_session / signin_session_token response body (JSON or PHP print_r).
export const parseSessionPayload = (body) => {
  if (!body || typeof body !== 'string') {
    return {};
  }

  const trimmed = body.trim();
  if (!trimmed) {
    return {};
  }

  // Prefer JSON if server returns it.
  try {
    const json = JSON.parse(trimmed);
    if (json && typeof json === 'object' && !Array.isArray(json)) {
      return json;
    }
  } catch (e) {
    // fall through to print_r / loose parsing
  }

  const result = {};
  const printRRegex = /\[([^\]]+)\]\s*=>\s*(.*)$/gm;
  let match;
  while ((match = printRRegex.exec(trimmed)) !== null) {
    const key = String(match[1] || '').trim();
    let value = String(match[2] || '').trim();
    if (!key) {
      continue;
    }
    // strip wrapping quotes from print_r strings
    if (
      (value.startsWith('"') && value.endsWith('"')) ||
      (value.startsWith("'") && value.endsWith("'"))
    ) {
      value = value.slice(1, -1);
    }
    result[key] = value;
  }

  if (Object.keys(result).length > 0) {
    return result;
  }

  // Loose fallback: zd_aichat: true / "zd_aichat":"true"
  const loose = /["']?zd_aichat["']?\s*[:=]\s*["']?(true|false|1|0)["']?/i.exec(trimmed);
  if (loose) {
    return { zd_aichat: loose[1] };
  }

  return {};
}

const isTruthyFlag = (flag) => {
  if (flag === undefined || flag === null) {
    return false;
  }
  if (typeof flag === 'boolean') {
    return flag;
  }
  const normalized = String(flag).trim().toLowerCase();
  return normalized === 'true' || normalized === '1' || normalized === 'yes';
}

// Fetch reload_session and resolve whether AI chat is enabled from body + cookies.
export const fetchAiChatEnabled = async () => {
  const phpApi = process.env.phpApiUrl;
  let payload = {};

  try {
    const res = await fetch(`${phpApi}/reload_session.php`, {
      credentials: 'include',
    });
    const body = await res.text();
    payload = parseSessionPayload(body);
  } catch (e) {
    payload = {};
  }

  const cookies = getCookie() || {};
  const flag = payload.zd_aichat !== undefined ? payload.zd_aichat : cookies.zd_aichat;
  return isTruthyFlag(flag);
}

// Returns raw server body from reload_session.php (print_r / JSON dump).
export const fetchReloadSessionRaw = async () => {
  const phpApi = process.env.phpApiUrl;
  const res = await fetch(`${phpApi}/reload_session.php`, {
    credentials: 'include',
  });
  const body = await res.text();

  return {
    ok: res.ok,
    status: res.status,
    body,
    parsed: parseSessionPayload(body),
  };
}